import React from 'react';
import Icon from 'jsx/components/core/icons/Icon';
import { InputGroup, InputGroupText, Input } from 'reactstrap';
import { noop } from 'lodash';

const SingleSearchInput = ({ onChange = noop, value, placeholder }) => (
    <InputGroup style={{ width: 300 }} className="mr-2" size="sm">
      <InputGroupText>
        <Icon name="magnifying-glass" />
      </InputGroupText>

      <Input
        className="h-auto"
        placeholder={placeholder}
        onChange={onChange}
        onKeyDown={onChange}
        value={value}
      />
    </InputGroup>
  );

export default SingleSearchInput;
